<div class="centered">
  <h1>We don't collect or share personal information.</h1>
  <h3>That's our privacy policy in a nutshell.</h3>
</div>
